import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const stateApi = createAsyncThunk("state", async () => {
  const response = await axiosInstance.get("/state");
  return response.data;
});

const stateSlice = createSlice({
  name: "state",
  initialState: {
    state: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(stateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(stateApi.fulfilled, (state, action) => {
        state.state = action.payload;
        state.loading = false;
      })
      .addCase(stateApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default stateSlice.reducer;
